import { ButtonContainer, DataTable, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import {
  FcbFormateurDiplomeGridDto,
  FichierApi,
  FormateurDiplomeApi,
  FormateurDiplomeSearch
} from "../../../../../../api";
import { ERoutes } from "../../../../../../AppRouter";
import { EditButton, LinkButton, ViewButton } from "../../../../../../components";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";

export interface IActiviteProfessionelleDiplomeListPageProps {
  idFormateur: number;
}

export const ActiviteProfessionelleDiplomeListPage: React.FunctionComponent<IActiviteProfessionelleDiplomeListPageProps> = ({
  idFormateur
}) => {
  const { t } = useTl();
  const api = useApiService(FormateurDiplomeApi);
  const history = useHistory();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { libelle: "ASC" }
  });
  const validateUrl = React.useCallback((url: string) => {
    if (url.includes("http")) {
      return url;
    }
    return `http://${url}`;
  }, []);

  const searchFunction = React.useCallback(
    (sObj?: FormateurDiplomeSearch) => {
      sObj.idformateur = idFormateur;
      return api.formateurDiplomeBaseSearch({ FormateurDiplomeSearch: sObj });
    },
    [api, idFormateur]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true
  });

  const fapi = useApiService(FichierApi);
  const downloadFn = React.useCallback(async idfichier => await fapi.fichierDownload({ id: idfichier }), [fapi]);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbFormateurDiplomeGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${ERoutes.formateur}/${idFormateur}/activitesProfessionnelles/Diplome/${row.iddiplome}/view`
                )
              }
            />
            <EditButton
              minimal={true}
              onClick={() =>
                history.push(
                  `${ERoutes.formateur}/${idFormateur}/activitesProfessionnelles/Diplome/${row.iddiplome}/edit`
                )
              }
            />
          </ButtonContainer>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      },
      {
        header: () => t(ETLCodes.Date),
        fieldName: "date"
      },
      {
        header: () => t(ETLCodes.Type),
        fieldName: "type"
      },
      {
        header: () => t(ETLCodes.URL),
        fieldName: "url",
        render: (row: FcbFormateurDiplomeGridDto) =>
          row.url && (
            <a target="_blank" rel="noopener noreferrer" href={validateUrl(row.url)}>
              {t(ETLCodes.Voir)}
            </a>
          )
      },
      {
        header: () => t(ETLCodes.Document),
        fieldName: "fichier",
        render: (row: FcbFormateurDiplomeGridDto) =>
          row.fileName &&
          (row.idfichier ? <LinkButton text={row.fileName} onClick={() => downloadFn(row.idfichier)} /> : row.fileName)
      }
    ],
    [downloadFn, history, idFormateur, t, validateUrl]
  );

  return (
    <DataTable
      dateFormat="dd-MM-yyyy"
      tableState={tableState}
      loading={loading}
      columns={columns}
      filterMode="OnEnter"
    />
  );
};
